import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { MenuSidebar } from '../components/menu';
import { Header } from '../components/header';
import { useEffect, useMemo, useState } from 'react';
import {
  extractColumnsFromRefresh,
  formatNumber,
  FreePrice,
  FreePriceTest,
  getConvertDataProjects,
  getDataWithGroupedViews,
  getExcelColumnLetters,
  getLocalStorage,
  getMapProjects,
  getWorkspace,
  isColumnGroupable,
  ProMonthlyPrice,
  ProMonthlyPriceTest,
  setLocalStorage
} from '../../../../utils';
import { useAuth } from '../../../../../../scripts/fb';
import axios from 'axios';
import {
  useAccountHasFreePlan,
  useAccountHasPlanPaid,
  useAccountHasStarterPlan,
  useAccountHasTrialPlanPaid,
  useExpandFileUpload,
  useIsAppDown,
  useIsFirebaseDown,
  useIsReadyFile,
  useSheetName,
  useShowErrorModalComingSoon,
  useShowsSheetsScreen,
  useShowStepsUploading
} from '../../../../lib/store/dashboard.store';
import {
  useAccountHasLillyPaid,
  useFinishProjectDataUpdateModal
} from '../../../../lib/store/frame.store';
import { VideoModal } from '../../../UI/modal/Error/video-popup';
import {
  unSaveChangesSettingsModal,
  useActivateInteractiveModules,
  useCancelSettingsModal,
  useChartColors,
  useConfirmSettingsModal,
  useDeactivateMenu,
  useDynamicTextErrorModal,
  useFileDetails,
  useFileUploaded,
  useGenericErrorModal,
  useHasAccountRestrictions,
  useHasBasicConfig,
  useMenuBar,
  useMyFilesData,
  useNavigationMenu,
  useNewLillyClaim,
  useProjectNumbers,
  useSetGenericError,
  useShowChartLabel,
  useShowConfigTutorial,
  useShowGlobalConfig,
  useShowManageAccount,
  useShowsModalError,
  useShowUpgradeLoader,
  useShowUploadFileTutorial,
  useTrialExpired,
  useWorkspaceStore
} from '../../../../lib/store/v3/layout';
import { ModalError } from '../../../UI/modal/Error';
import {
  useFileAttached,
  useFileUploadedState,
  useShowNoSavedChangesModal
} from '../../../../lib/store/settings.store';
import { useMutation } from 'react-query';
import { Modal } from '../../../UI/modal';
import { UpgradePlanModal } from '../../../UI/modal/upgrade-plan';
import { AppDownPage } from './app-down';
import { useUpgradeNavigation } from '../../../../customHooks/useHasUpgrade';
import { SentryReportError } from '../../../../../utils';
import { Userpilot } from 'userpilot';
import { Loader } from '../../../UI/loader';
import { baseurl } from '../../../../constant';
import { useCollectionMutations } from '../../../../customHooks/useCollectionMutations';

export const Layout = () => {
  const navigate = useNavigate();
  const auth = useAuth();
  const accountPaid = useAccountHasPlanPaid((state: any) => state.accountPaid);
  const newLillyClaim = useNewLillyClaim((state: any) => state.newLillyClaim);
  const setAccountPaid = useAccountHasPlanPaid((state: any) => state.setAccountPaid);
  const setAccountLillyPaid = useAccountHasLillyPaid((state: any) => state.setAccountPaid);
  const setStarterAccount = useAccountHasStarterPlan((state: any) => state.setAccountPaid);
  const starterAccount = useAccountHasStarterPlan((state: any) => state.accountPaid);
  const trialAccountPaid = useAccountHasTrialPlanPaid((state: any) => state.trialAccountPaid);
  const setTrialAccountPaid = useAccountHasTrialPlanPaid((state: any) => state.setTrialAccountPaid);
  const showTutorial = useShowUploadFileTutorial((state: any) => state.showTutorial);
  const setShowTutorial = useShowUploadFileTutorial((state: any) => state.setShowTutorial);
  const sheetName = useSheetName((state: any) => state.name);
  const setSheetName = useSheetName((state: any) => state.setName);
  const setFreeAccount = useAccountHasFreePlan((state: any) => state.setFreeAccount);
  /*
  Dasboard states
  */
  // const [showModalError, setShowModalError] = useState<boolean>(false);
  const showModalError = useShowsModalError((state: any) => state.showModalError);
  const setShowModalError = useShowsModalError((state: any) => state.setShowModalError);
  const setHasRestrictions = useHasAccountRestrictions((state: any) => state.setHasRestrictions);
  const [errorMsg, setErrorMsg] = useState<string>('');
  const headerTextForNoPlan = useDynamicTextErrorModal((state: any) => state.headerTextForNoPlan);
  const setHeaderTextForNoPlan = useDynamicTextErrorModal(
    (state: any) => state.setHeaderTextForNoPlan
  );
  // const [genericError, setGenericError] = useState<boolean>(false);
  const genericError = useGenericErrorModal((state: any) => state.genericError);
  const setGenericError = useGenericErrorModal((state: any) => state.setGenericError);
  const [openUpgradeModal, setOpenUpgradeModal] = useState<boolean>(false);
  const { handleUpgradeNavigation } = useUpgradeNavigation();
  const [showLogo, setShowLogo] = useState<boolean>(false);
  const [headersError, setHeaderError] = useState<boolean>(false);
  const [isSAVFile, setIsSAVFile] = useState<boolean>(false);
  const [openModal, setOpenModal] = useState<boolean>(false);
  const fileAttached = useFileAttached((state: any) => state.file);
  const setFileAttached = useFileAttached((state: any) => state.setFileAttached);
  const setFileUploadedState = useFileUploadedState((state: any) => state.setFileUploadedState);
  const isFileUploadedState = useFileUploadedState((state: any) => state.fileUploadedState);
  const isFileUploaded = useFileUploaded((state: any) => state.isFileUploaded);
  const setIsFileUploaded = useFileUploaded((state: any) => state.setIsFileUploaded);
  const setIsReadyFile = useIsReadyFile((state: any) => state.setIsReady);
  const [isUploadingData, setIsUploadingData] = useState<boolean>(false);
  const [isUpgradeToAccess, setIsUpgradeToAccess] = useState<boolean>(false);
  const setProjectUpdated = useFinishProjectDataUpdateModal((state: any) => state.setChecks);
  const setExpand = useExpandFileUpload((state: any) => state.setExpand);
  const expand = useExpandFileUpload((state: any) => state.expand);
  const setShowSteps = useShowStepsUploading((state: any) => state.setShowSteps);
  const [alreadyDontMatchStatus, setAlreadyDontMatchStatus] = useState<boolean>(false);
  const [columnsDontMatch, setColumnsDontMatch] = useState<boolean>(false);
  const [columnsRemovedArr, setColumnsRemovedArr] = useState<any>();
  const [columnsAddedArr, setColumnsAddedArr] = useState<any>();
  const setShowSheetsScreen = useShowsSheetsScreen((state: any) => state.setShow);
  /*End Dashboard */
  const setNavigation = useNavigationMenu((state: any) => state.setNavigation);
  const setActivateInteractiveM = useActivateInteractiveModules((state: any) => state.setActivate);

  const location = useLocation().pathname;
  const setFileSelected = useFileDetails((state: any) => state.setFileSelected);
  const fileSelected = useFileDetails((state: any) => state.fileSelected);
  const navigation = useNavigationMenu((state: any) => state.navigation);
  const setUnSaveChangesModal = unSaveChangesSettingsModal(
    (state: any) => state.setUnSaveChangesModal
  );
  const unSaveChangesModal = unSaveChangesSettingsModal((state: any) => state.unSaveChangesModal);
  const setConfirmModal = useConfirmSettingsModal((state: any) => state.setConfirmModal);
  const setCancelModal = useCancelSettingsModal((state: any) => state.setCancelModal);
  const showModal = useShowNoSavedChangesModal((state: any) => state.showModal);
  const setOpenMenu = useMenuBar((state: any) => state.setOpenMenu);
  const showConfigTutorial = useShowConfigTutorial((state: any) => state.showTutorial);
  const setIsAppDown = useIsAppDown((state: any) => state.setIsAppDown);
  const isAppDown = useIsAppDown((state: any) => state.isAppDown);
  const setIsFirebaseDown = useIsFirebaseDown((state: any) => state.setIsAppDown);
  const isFirebaseDown = useIsFirebaseDown((state: any) => state.isAppDown);
  const setCurrentWorkspace = useWorkspaceStore((state) => state.setCurrentWorkspace);
  const setTrialExpired = useTrialExpired((state: any) => state.setTrialExpired);
  const setNumProjects = useProjectNumbers((state: any) => state.setNumProjects);
  const showModalErrorComingSoon = useShowErrorModalComingSoon(
    (state: any) => state.showModalError
  );
  const setShowStripeLink = useShowManageAccount((state: any) => state.setShowStripeLink);
  const setNewLillyClaim = useNewLillyClaim((state: any) => state.setNewLillyClaim);
  const setShowGenericError = useSetGenericError((state: any) => state.setShowGenericError);
  const setShowUpgradeLoader = useShowUpgradeLoader((state: any) => state.setShowLoader);
  const [showLoader, setShowLoader] = useState<boolean>(false);
  const setDeactivateMenu = useDeactivateMenu((state: any) => state.setDeactivate);
  const setRowsAgGrid = useMyFilesData((state: any) => state.setMyFilesData);
  const { geCollection } = useCollectionMutations();
  const setBasicConfig = useHasBasicConfig((state: any) => state.setConfig);
  const setThemeColors = useChartColors((state: any) => state.setColors);
  const setShowCounters = useShowChartLabel((state: any) => state.setShowLabels);
  const setIsGlobalConfig = useShowGlobalConfig((state: any) => state.setGlobalConfig);

  useEffect(() => {
    if (showModalErrorComingSoon) {
      setShowModalError(true);
    }
  }, [showModalErrorComingSoon]);

  useEffect(() => {
    const idFile = getWorkspace(location);
    const files: any = getLocalStorage('FilesSelected');
    const fileDetails = files?.find((e) => e.id === idFile);
    if (fileDetails) {
      setFileSelected(fileDetails);
    } else if (
      !fileSelected ||
      navigation == 'new-file' ||
      navigation == 'my-files' ||
      navigation == 'data-connectors'
    )
      setFileSelected(null);
  }, [location, navigation]);

  const removeFileByError = (
    text: string,
    workspace,
    genericError,
    fromReload,
    removeFileShortened?
  ) => {
    setShowGenericError(false);
    if (genericError) {
      setGenericError(true);
      setHeaderTextForNoPlan('');
    } else {
      setGenericError(false);
    }
    setShowModalError(true);
    if (!removeFileShortened) localStorage.removeItem('file-shortened');
    setIsUpgradeToAccess(false);
    if (text && text.length > 0) setErrorMsg(text);
    const payload = {
      file: workspace
    };
    if (!fromReload) deleteProjectUploaded.mutate(payload);
    if (fromReload) {
      setProjectUpdated(true);
    }
    setFileUploadedState(false);
    setOpenModal(false);
    setIsFileUploaded(false);
    setIsUploadingData(false);
  };

  const applySettingsProject = useMutation(async (payload: any) => {
    const token = await auth.user?.getIdToken();
    if (!token) return;
    try {
      const response = await axios.put(
        `/apply_settings/${payload.workspaceid}`,
        {},
        {
          headers: {
            Authorization: token
          }
        }
      );
      if (response && response.status == 200) {
      }
    } catch (error: any) {
      SentryReportError(error, {
        payload: payload || null
      });
      if (error.code == 'ERR_NETWORK') {
        setIsAppDown(true);
      } else {
        setLocalStorage('token', null);
        setLocalStorage('userData', null);
        window.open('/', '_self');
      }
    }
  });

  const includeColumns = useMutation(async (payload: any) => {
    const token = await auth.user?.getIdToken();
    if (!token) return;
    try {
      const response = await axios.put(`/settings/${payload.workspaceid}`, payload.data, {
        headers: {
          Authorization: token
        }
      });
      if (response && response.status == 200) {
        const settingsPayload = {
          workspaceid: payload.workspaceid
        };
        applySettingsProject.mutate(settingsPayload);
      }
    } catch (error: any) {
      SentryReportError(error, {
        payload: payload || null
      });
      if (error.code == 'ERR_NETWORK') {
        setIsAppDown(true);
      } else {
        setLocalStorage('token', null);
        setLocalStorage('userData', null);
        window.open('/', '_self');
      }
    }
  });

  const getProject = async (payload: any) => {
    try {
      const token = await auth.user?.getIdToken();
      if (!token) return;
      const timestamp = Date.now();
      const route = `/project/${payload.workspace}?timestamp=${timestamp}`;
      const response = await axios.get(route, {
        params: {
          workspace: payload.workspace
        },
        headers: {
          Authorization: token
        }
      });
      if (response && response.data && response.status == 200) {
        const res = response.data;
        const msg = res?.message;
        const info = res?.file_info;
        const endUpLoader = getLocalStorage('endUploadLoader') ?? false;
        if (res?.completed === 'yes' && msg === 'success') {
          const isShortened = info?.shortened ?? false;
          setFileAttached('');
          setIsReadyFile(true);
          if (payload?.fromUpload && !endUpLoader) {
            setTimeout(() => {
              getProject(payload);
            }, 1000);
          } else if ((payload?.fromUpload && endUpLoader) || !payload?.fromUpload) {
            setIsFileUploaded(false);
            setIsReadyFile(false);
            setTimeout(() => {
              setSheetName('');
            }, 2000);
            const mapData: any = getConvertDataProjects(res);
            const groupedViews = getDataWithGroupedViews(mapData?.settings);
            let dataRequest = {};
            let atLeastOneChange = false;
            groupedViews?.forEach((element) => {
              const isGroupable = isColumnGroupable(element?.label, groupedViews);
              if (element && element?.exclude && (element?.countValues > 1 || isGroupable)) {
                atLeastOneChange = true;
                dataRequest = {
                  ...dataRequest,
                  [element.id]: { exclude: false }
                };
              }
            });
            if (atLeastOneChange && !payload?.fromReload) {
              const payloadIncluded = {
                data: dataRequest,
                workspaceid: payload.workspace
              };
              includeColumns.mutate(payloadIncluded);
            }
            if (payload?.fromReload) {
              setProjectUpdated(true);
            }
            if (isShortened) {
              setShowModalError(true);
              setHeaderTextForNoPlan('');
            } else localStorage.removeItem('file-shortened');
            setTimeout(() => {
              setExpand(false);
            }, 1500);
            setShowSteps(false);
            setNavigation('ai-chat');
            Userpilot.track('ai_analyst_page');
            setActivateInteractiveM(true);
            setOpenMenu(true);
            let rows = getMapProjects([response.data]);
            setFileSelected(rows[0]);
            setCurrentWorkspace(payload.workspace);
            setRowsAgGrid([]);
            navigate(`/chat/${payload.workspace}`);
          }
        } else if (
          (res?.completed === 'no' &&
            msg !== 'success' &&
            msg !== 'initialized' &&
            !msg.includes('processing') &&
            !msg.includes('applying excel sheet')) ||
          (res?.completed === 'yes' && msg !== 'success')
        ) {
          if (
            msg ===
            'An error occurred (ValidationException) when calling the UpdateItem operation: ExpressionAttributeValues contains invalid value: Item size has exceeded the maximum allowed size for key :val1'
          ) {
            removeFileByError(
              'Metadata exceeds size limit. Try removing unnecessary columns and reloading the file',
              payload.workspace,
              false,
              payload?.fromReload
            );
          } else if (msg.includes('Columns with the same name are not supported')) {
            removeFileByError(
              'Columns with the same name are not supported. Check column names and reload the file.',
              payload.workspace,
              false,
              payload?.fromReload
            );
          } else if (msg.includes('do not match columns of the existing file')) {
            if (!alreadyDontMatchStatus) {
              setColumnsDontMatch(true);
              const result = extractColumnsFromRefresh(msg);
              if (result.columnsRemoved) {
                setColumnsRemovedArr(result.columnsRemoved);
              }
              if (result.columnsAdded) {
                setColumnsAddedArr(result.columnsAdded);
              }
            } else {
              setTimeout(() => {
                getProject(payload);
              }, 5000);
            }
          } else if (msg.includes('The file contains unnamed columns')) {
            const value = msg.split(':')[1];
            const array = JSON.parse(value);
            const numberOfValues = array.length;
            setHeaderError(true);
            if (numberOfValues < 6) {
              const outputLetters = getExcelColumnLetters(array);
              setHeaderTextForNoPlan(
                `<div class='flex flex-row justify-center gap-4 pt-1.5 mr-6'><img src="/icons/warning-upload.svg" className="" alt="Candle" /><span>The following columns are missing a title:</span></div>
                <div class='pt-1'><span>${outputLetters}</span></div>
                 <div class='mt-6 mb-3 ml-2.5'><b>How to fix it:</b></div>   <div class='flex flex-col gap-1 text-left max-w-[416px] ml-14'> <ol class='list-decimal list-inside'> <li class='text-left'>Add a title to these columns</li> <li class='text-left'>Make sure there are no merged cells</li> <li class='text-left'>Check that all columns have a title</li> </ol> </div> `
              );
            } else {
              setHeaderTextForNoPlan(
                `<div class='flex flex-row justify-center gap-4 pt-1.5 mr-6'><img src="/icons/warning-upload.svg" className="" alt="Candle" /><span>Header is missing from row 1 or several columns are missing a title </span></div>
                <div class='mt-6 mb-3'><b>How to fix it:</b></div>  <div class='flex flex-col gap-1 text-left max-w-[416px] ml-36'> <ol class='list-decimal list-inside'> <li class='text-left'>Make sure the header is in row 1</li> <li class='text-left'>Make sure there are no merged cells</li> <li class='text-left'>Check that all columns have a title</li> </ol> </div> `
              );
            }
            removeFileByError(
              `Uh-oh... Something went wrong 😬`,
              payload.workspace,
              false,
              payload?.fromReload
            );
          } else if (msg.includes('empty column header')) {
            setHeaderError(true);
            setHeaderTextForNoPlan(
              '<div class="flex flex-row justify-center gap-4 pt-1.5"><img src="/icons/warning-upload.svg" className="" alt="Candle" /><span>Looks like there is a column with no title</span></div> <div class="mt-6 mb-3 ml-2.5"><b>How to fix it:</b></div>  <div class="flex flex-col gap-1 text-left max-w-[416px] ml-20"> <ol class="list-decimal list-inside"> <li class="text-left">Add a title to all columns in the header row</li> <li class="text-left">Go to the last column with data and delete the columns that follow to the right</li> </ol> </div>'
            );
            removeFileByError(
              `Uh-oh... Something went wrong 😬`,
              payload.workspace,
              false,
              payload?.fromReload
            );
          } else if (msg.includes('exceeds max dimensions') || msg.includes('imed out')) {
            setLocalStorage('file-shortened', true);
            setLocalStorage('max-rows-restric', true);
            removeFileByError(``, payload.workspace, false, false, true);
            setHeaderTextForNoPlan && setHeaderTextForNoPlan('');
          } else if (
            msg.includes("object has no attribute 'str'") ||
            msg.includes('repeated columns')
          ) {
            setHeaderError(true);
            setHeaderTextForNoPlan(
              `<div class='flex flex-row justify-center gap-4 pt-1.5'><img src="/icons/warning-upload.svg" className="" alt="Candle" /><span>Two or more columns have the same header</span></div> <div class='mt-6 mb-3 ml-2.5'><b>How to fix it:</b></div>  <div class='flex flex-col gap-1 text-left max-w-[416px] ml-20'> <ol class='list-decimal list-inside'> <li class='text-left'>Check for columns with identical headers.</li> <li class='text-left'>Make sure all the columns have different headers.</li> </ol> </div> `
            );
            removeFileByError(
              `Uh-oh... Something went wrong 😬`,
              payload.workspace,
              false,
              payload?.fromReload
            );
          } else {
            removeFileByError(
              `Uh-oh... Something went wrong 😬`,
              payload.workspace,
              true,
              payload?.fromReload
            );
          }
          setSheetName('');
          setTimeout(() => {
            setExpand(false);
          }, 1500);
          setShowSteps(false);
          setIsFileUploaded(false);
        } else if (res?.completed === 'no') {
          setTimeout(() => {
            getProject(payload);
          }, 5000);
        }
      }
    } catch (error: any) {
      SentryReportError(error, {
        payload: payload || null
      });

      if (error.code == 'ERR_NETWORK') {
        setIsAppDown(true);
      } else if (
        error?.response?.status == 403 ||
        error?.message === 'auth.user?.getIdToken is not a function' ||
        error?.response?.status == 401 ||
        !error?.response
      ) {
        setLocalStorage('token', null);
        setLocalStorage('userData', null);
        window.open('/', '_self');
      } else {
        setFileUploadedState(false);
        setOpenModal(false);
        setIsFileUploaded(false);
        setIsUploadingData(false);
        setShowSheetsScreen(false);
      }
      setExpand(false);
      setShowSteps(false);
    }
  };

  const freeSubscription = useMutation(async (payload: any) => {
    const token = await auth.user?.getIdToken();
    const apiCalledAlready = getLocalStorage('freeSubscriptionAPI-done') ?? false;
    if (apiCalledAlready) localStorage.removeItem('freeSubscriptionAPI-done');
    if (!token || apiCalledAlready) return;
    setLocalStorage('freeSubscriptionAPI-done', true);
    const route = `/switch_to_free_subscription`;
    try {
      const response = await axios.post(
        route,
        {
          price_id: payload.priceId
        },
        {
          headers: {
            Authorization: token
          }
        }
      );
      if (response && response.status === 200) {
        setTimeout(() => {
          setShowUpgradeLoader(false);
        }, 2000);
        setFreeAccount(true);
      }
    } catch (error: any) {
      SentryReportError(error, {
        payload: payload || null
      });
      console.log(error);
    }
  });

  const getClaims = async (payload) => {
    try {
      const token = await auth.user?.getIdToken();
      if (!token) return;
      const timestamp = Date.now();
      const response = await axios.get(`/projects?timestamp=${timestamp}`, {
        headers: {
          Authorization: token,
          'Cache-Control': 'no-store'
        }
      });
      if (response && response.status === 200) {
        const rows = getMapProjects(response.data?.projects);
        const mapRows = rows.map((e: any) => {
          return {
            ...e,
            rows: formatNumber(e.rows),
            columns: formatNumber(e.columns),
            rowsInt: e.rows
          };
        });
        setLocalStorage('FilesSelected', mapRows);
        const claims = response.data?.claims;
        const projects = response.data?.projects;
        setNumProjects(projects.length);
        const hasPaidPlan = !!claims?.find((e) => e === 'paid');
        const starterPlan = !!claims?.find((e) => e === 'starter');
        const hasReloadClaim = !!claims?.find((e) => e === 'reloading');
        const hasTrialClaim = !!claims?.find((e) => e === 'trial');
        const hasLillyPlan = !!claims?.find((e) => e == 'lilly crl') && hasPaidPlan;
        const hasFreeAccount = !!claims?.find((e) => e === 'free');
        const hasNewLillyClaim = !!claims?.find((e) => e == 'lilly');
        setLocalStorage('hasReloadClaim', hasReloadClaim);
        const trialCheckCount = Number(getLocalStorage('trial-check-count') || 0);
        if (
          ((claims.length == 1 && claims[0] == 'trial') ||
            (claims.length == 2 && claims[1] == 'trial')) &&
          trialCheckCount < 10
        ) {
          setLocalStorage('trial-check-count', trialCheckCount + 1);
          setTimeout(() => {
            const payloadClaims = {
              tokenStartedTrial: null
            };
            getClaims(payloadClaims);
            const payloadSession = {
              domain: window.location.origin,
              tokenStartedTrial: null
            };
            checksPortalSession.mutate(payloadSession);
            setShowLoader(true);
          }, 5000);
        } else {
          localStorage.removeItem('trial-check-count');
          setShowLoader(false);
          if (hasNewLillyClaim) {
            setNewLillyClaim(hasNewLillyClaim);
            setAccountLillyPaid(hasLillyPlan);
          } else {
            if (!starterPlan && !hasPaidPlan && !hasLillyPlan) setFreeAccount(hasFreeAccount);
            if (!hasPaidPlan && !hasLillyPlan && !hasTrialClaim) setStarterAccount(starterPlan);
            setAccountPaid(hasPaidPlan);
            setAccountLillyPaid(hasLillyPlan);
            setTrialAccountPaid(hasTrialClaim);
          }
          const domain = window.location.origin;
          const isUat = domain.includes('uat') || domain.includes('localhost') ? true : false;
          if (claims.length == 1 && claims[0] == '') {
            const payload = {
              priceId: isUat ? FreePriceTest : FreePrice
            };
            // freeSubscription.mutate(payload);
            setDeactivateMenu(true);
            navigate('/upgrade');
            setNavigation('upgrade');
            // setShowUpgradeLoader(true);
            setLocalStorage('trial-expired', true);
            setTrialExpired(true);
            handleUpgradeNavigation(location);
          } else {
            localStorage.removeItem('trial-expired');
            setDeactivateMenu(false);
          }
          setTimeout(() => {
            const payloadSession = {
              domain: window.location.origin,
              tokenStartedTrial: null
            };
            checksPortalSession.mutate(payloadSession);
          }, 3000);
        }
        setLocalStorage('showsStripeLoader', false);
      }
    } catch (error: any) {
      SentryReportError(error, {
        payload: payload || null
      });
      if (error.code == 'ERR_NETWORK') {
        setIsAppDown(true);
      } else {
        setLocalStorage('token', null);
        setLocalStorage('userData', null);
        window.open('/', '_self');
      }
    }
  };

  const checksPortalSession = useMutation(async (payload: any) => {
    const token = await auth.user?.getIdToken();
    if (!token) return;
    const route = `/portal_session`;
    try {
      const response = await axios.post(
        route,
        {
          return_url: payload.domain
        },
        {
          headers: {
            Authorization: token
          }
        }
      );
      if (response && response.status === 200) {
        setShowStripeLink(true);
      }
    } catch (error: any) {
      SentryReportError(error, {
        payload: payload || null
      });
      console.log('Error from portal session: ', error);
      if (error?.response?.data?.detail?.includes('No stripe customers found for email')) {
        setShowStripeLink(false);
      }
    }
  });

  useEffect(() => {
    let emailBlast = getEmailBlast();
    const tokenStartedTrial = getLocalStorage('start-trial-period-token');
    if (auth.isFirebaseDown) {
      setIsFirebaseDown(true);
    } else if (!emailBlast && auth.user) {
      setLocalStorage('showsStripeLoader', true);
      const payloadClaims = {
        tokenStartedTrial: tokenStartedTrial
      };
      getClaims(payloadClaims);
      const payload = {
        domain: window.location.origin,
        tokenStartedTrial: tokenStartedTrial
      };
      checksPortalSession.mutate(payload);
      setTimeout(() => {
        const payload = {
          domain: window.location.origin,
          tokenStartedTrial: tokenStartedTrial
        };
        checksPortalSession.mutate(payload);
      }, 7000);
      localStorage.removeItem('isAlreadyOpen-reports');
      localStorage.removeItem('lastNewX');
      localStorage.removeItem('scrollActivated');
      localStorage.removeItem('myViewsDashboardActive');
    }
  }, [auth.user]);

  const updateStatusUploading = () => {
    setFileUploadedState(false);
    setOpenModal(false);
    setIsFileUploaded(false);
    // setIsUploadingData(false);
  };

  const deleteProjectUploaded = useMutation(async (payload: any) => {
    const token = await auth.user?.getIdToken();
    if (!token) return;
    try {
      const response = await axios.delete(`/project/${payload.file}`, {
        params: {
          workspace: payload.file
        },
        headers: {
          Authorization: token
        }
      });
      if (response && response.data && response.status == 200) {
        if (payload.fromUpload) {
          updateStatusUploading();
        }
      }
    } catch (error: any) {
      SentryReportError(error, {
        payload: payload || null
      });
      if (error.code == 'ERR_NETWORK') {
        setIsAppDown(true);
      } else {
        setLocalStorage('token', null);
        setLocalStorage('userData', null);
        window.open('/', '_self');
      }
    }
  });

  useEffect(() => {
    if (isFileUploadedState && sheetName.length > 0) {
      const isFreeAccount = !accountPaid && !starterAccount && !trialAccountPaid && !newLillyClaim;
      const isSavExtension = getLocalStorage('extension-file');
      const file = fileAttached ?? getLocalStorage('workspace-sheet');
      if (isFreeAccount && isSavExtension == 'sav') {
        const payload = {
          file: file
        };
        deleteProjectUploaded.mutate(payload);
        setShowModalError(true);
        setHeaderTextForNoPlan('SAV files are not supported in your plan');
        setIsSAVFile(true);
        setIsFileUploaded(false);
        setOpenModal(false);
        setHasRestrictions(false);
      } else {
        getProject({ workspace: file, callProjects: true, fromUpload: true });
      }
      localStorage.removeItem('workspace-sheet');
      localStorage.removeItem('extension-file');
    }
  }, [isFileUploadedState]);

  const handleClickUpgradeError = () => {
    // setOpenUpgradeModal(true);
    handleUpgradeNavigation(location);
    setShowLogo(true);
    setShowModalError(false);
    setHasRestrictions(false);
  };

  useMemo(() => {
    // check this out, similar than configuration.tsx
    if (showModal) {
      setUnSaveChangesModal(true);
    }
  }, [showModal]);

  const enableFreeTrialAPI = useMutation(async (payload: any) => {
    const domain = window.location.origin;
    const isUat = domain.includes('uat') || domain.includes('localhost') ? true : false;
    const token = await auth.user?.getIdToken();
    const apiCalledAlready = getLocalStorage('enableFreeTrialAPI-done') ?? false;
    if (apiCalledAlready) localStorage.removeItem('enableFreeTrialAPI-done');
    if (!token || payload?.tokenStartedTrial == token || apiCalledAlready) return;
    const route = `/enable_free_trial`;
    setLocalStorage('enableFreeTrialAPI-done', true);
    try {
      const response = await axios.post(
        route,
        {
          price_id: isUat ? ProMonthlyPriceTest : ProMonthlyPrice,
          trial_days: +payload.trial,
          trial_activated: true
        },
        {
          headers: {
            Authorization: token
          }
        }
      );
      if (response && response.status === 200) {
        setLocalStorage('start-trial-period-token', token);
        localStorage.removeItem('email-blast');
        setTrialAccountPaid(true);
      }
    } catch (error: any) {
      SentryReportError(error, {
        payload: payload || null
      });
      console.log(error);
    }
  });

  const getCollectionApi = async () => {
    try {
      const fileid = getWorkspace(location);
      if (fileid) {
        const collection = `basic-config-${fileid}`;
        const result = await geCollection(collection);
        if (result && Object.keys(result).length > 0) {
          setBasicConfig(result);
          // will be deactivated for now
          // if (result && result.hasGlobalConfig) {
          //   setThemeColors(result.globalConfig.themeColors);
          //   setShowCounters(result.globalConfig.showCounters);
          //   setIsGlobalConfig(result.hasGlobalConfig);
          // } else
          // if (result && !result.hasGlobalConfig) {
          const fileConfig = result?.chartConfig?.file == fileid;
          if (fileConfig) {
            setThemeColors(result.chartConfig.themeColors);
            setShowCounters(result.chartConfig.showCounters);
          }
          // }
        }
      }
    } catch (err: any) {
      // setError(err?.message || 'Unknown error');
    } finally {
      // setLoading(false);
    }
  };

  useEffect(() => {
    let emailBlast = getEmailBlast();
    const tokenStartedTrial = getLocalStorage('start-trial-period-token');
    if (emailBlast && emailBlast?.from == 'email') {
      setShowUpgradeLoader(false);
      const payload = {
        trial: emailBlast.trial,
        tokenStartedTrial: tokenStartedTrial
      };
      enableFreeTrialAPI.mutate(payload);
    }
    // get configuration for the app
    if (auth?.user) {
      getCollectionApi();
    }
  }, [auth, auth?.user]);

  const getEmailBlast = () => {
    let emailBlast: any = getLocalStorage('email-blast');
    if (emailBlast) {
      emailBlast = JSON.parse(emailBlast);
    } else emailBlast = null;
    return emailBlast;
  };

  useEffect(() => {
    if (auth?.user) {
      Userpilot.identify(auth.user.uid, {
        name: auth.user.displayName,
        email: auth.user.email
      });
      Userpilot.reload();
    }
  }, [auth, auth?.user, location]);

  return (
    <div className={`${showTutorial ? 'opacity-90' : ''} flex h-screen font-montserrat`}>
      <MenuSidebar />

      <div className="flex-1 flex flex-col">
        <Header />

        <div className="flex-1 bg-white">
          {showLoader ? (
            <div className="2xl:pt-40 pt-32">
              {' '}
              <Loader showText={false} />
            </div>
          ) : (
            <>
              {' '}
              <main className="content">
                {isAppDown || isFirebaseDown ? <AppDownPage /> : <Outlet />}
              </main>
            </>
          )}
        </div>
      </div>

      {showTutorial && (
        <VideoModal
          isSettingsHelp={showConfigTutorial}
          openModal={showTutorial}
          setOpenModal={setShowTutorial}
        />
      )}
      {showModalError && (
        <ModalError
          openModal={showModalError}
          setOpenModal={() => setShowModalError(!showModalError)}
          error={errorMsg}
          headerTextForNoPlan={headerTextForNoPlan}
          isGenericError={genericError}
          handleClickUpgrade={handleClickUpgradeError}
          headersError={headersError}
          setHeaderError={setHeaderError}
          isSAVFile={isSAVFile}
          setIsSAVFile={setIsSAVFile}
          setOpenUploadModal={setOpenModal}
        />
      )}

      {unSaveChangesModal && (
        <Modal
          openModal={unSaveChangesModal}
          setUnSaveChangesModal={setUnSaveChangesModal}
          type="unsavechanges"
          title="Oops! Looks like you have some unsaved changes"
          setConfirm={setConfirmModal}
          setCancel={setCancelModal}
        />
      )}

      {openUpgradeModal && (
        <UpgradePlanModal
          openModal={openUpgradeModal}
          hasLogo={false}
          text=""
          isUpgradeToAccess={true}
        />
      )}
    </div>
  );
};
